import $ from 'jquery';
import { loadSlick } from './utils/slickLoader.js';

export function setupProjects() {
  if ($('body').hasClass('Projects')) {
    loadSlick().then(() => {

      $('.filter').on('click', function () {
        $('.filter').removeClass('current');
        $(this).addClass('current');

        const containerClass = $(this).attr('data-container');
        $('.container').removeClass('visible');
        let $container = $('.container.' + containerClass);
        $container.addClass('visible');

        if(!$container.hasClass('initialised')) {
          setupProjectOverview($container);
        } else {
          $container.find('.projects-container .projects').slick('setPosition');
        }

      });

      setupProjectOverview( $('.container.category'));

      function setupProjectOverview($container) {

        $container.find('.projects-container .projects').each(function () {
          $(this).slick({
            dots: false,
            infinite: false,
            speed: 800,
            mobileFirst: true
          });
        });

        $container.find('.overviewGalleryContainer').each(function () {
          const curElWidth = $(this).width();
          const numImages = $(this).find('img').length;

          $(this).find('.images').width(numImages * curElWidth);
          $(this).find('.images img').width((100 / numImages).toFixed(2) + '%');
        });

        $container.addClass('initialised');
      }

    });
  }
}